<template>
  <profile-card title="Followings">
    <div class="tw-grid tw-divide-y tw-divide-gray-200">
      <v-follow-item v-for="other_user in users" :user="other_user" :key="other_user.id">
        <v-follow-user :initial_is_following="true" :user='user' :other_user_id="other_user.id" v-slot="{is_following,toggle_follow}">
          <button v-on:click.prevent="toggle_follow" :class="`${is_following ? 'tw-text-white tw-bg-red tw-border-red' : 'tw-border-green tw-text-green hover:tw-text-white hover:tw-bg-green hover:tw-border-green'}`"
            class="tw-rounded tw-border tw-px-4 tw-py-1 tw-font-bold">
            {{ is_following ? 'Unfollow' : 'Follow' }}
          </button>
        </v-follow-user>
      </v-follow-item>
    </div>
    <div v-if="users.length === 0" class="tw-py-40 tw-text-center tw-text-gray-500 tw-text-3xl tw-uppercase">No Follows</div>
  </profile-card>
</template>
<script>
  export default {
    props: {
      initialUsers: {},
      user: {},
    },
    data: v => ({
      users: v.initialUsers
    }),
  }
</script>
